import {
  EnhancedDropDownRHF,
  IEnhancedDropDownRHF,
} from "../EnhancedDropDownRHF";

import { FieldLayout } from "../FieldLayout";
import { LabelPosition } from "../../common/enums";
import { LayoutWithLabel } from "../../interfaces";
import React from "react";

export interface IEnhancedDropDownRHFWithLabel
  extends IEnhancedDropDownRHF,
  LayoutWithLabel { }

/**
 * React Hook Form Drop Down component.
 */
export const EnhancedDropDownRHFWithLabel: React.FC<IEnhancedDropDownRHFWithLabel> =
  ({
    label,
    required,
    labelPosition = LabelPosition.Top,
    labelColumns = 4,
    fieldColumns = 8,
    selectName,
    selectedItem,
    showEmpty,
    isDisabled = false,
    isHide = false,
    isSearchable,
    items,
    testId,
    onSelectionChangeHandler,
  }) => {
    return (
      <FieldLayout
        label={label}
        isRequired={required}
        labelPosition={labelPosition}
        labelColumns={labelColumns}
        fieldColumns={fieldColumns}
        fieldTopPadding={1.1}
        testId={testId}
      >
        <EnhancedDropDownRHF
          items={items}
          selectedItem={selectedItem}
          showEmpty={showEmpty}
          testId={testId}
          selectName={selectName}
          isDisabled={isDisabled}
          isHide={isHide}
          isSearchable={isSearchable}
          onSelectionChangeHandler={onSelectionChangeHandler}
        />
      </FieldLayout>
    );
  };
